<template>
    <v-dialog width="500" v-model="showBOEDialog">
        <v-card>
            <v-card-title class="secondary white--text">
                <span> Update BOE on DA </span>

                <v-spacer></v-spacer>
                <v-btn icon @click="showBOEDialog = false">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-2">
                <v-form v-if="showBOEDialog" v-model="isValid">
                    <v-row class="ma-0">
                        <v-col cols="12" class="Form-Columns">
                            <InputField type="text" label="BOE/Reference Number *" hide-details="auto"
                                :rules="[(val) => !!val || 'BOE is required']" v-model="formDetails.boe"
                                :error-messages="formErrors.boe" @input="delete formErrors.po_no" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">
                <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">
                    Submit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";

export default {
    components: {
        InputField,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },

        boe: {
            type: [Number, String],
            default: null
        },
        id: {
            type: [Number, String],
            default: null
        }



    },
    computed: {
        showBOEDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {


            isValid: true,
            formErrors: {},
            formDetails: {},
        };
    },
    watch: {
        value(val) {
            if (val) {

                this.formDetails = {
                    boe: this.boe,
                    id: this.id
                };
            } else {
            }
        },
    },
    methods: {



        submitForm() {
            this.$bus.$emit("showLoader", true);
            let payload = {
                boe: this.formDetails.boe,
                id: this.formDetails.id

            };

            this.$api.deliveryAdvice
                .updateDABOE(payload)
                .then((res) => {
                    this.showBOEDialog = false;
                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: "BOE Updated Successfully!",
                        color: "success",
                    });
                    this.formErrors = {};
                    this.$emit("refreshList");
                })
                .catch((err) => {
                    this.formErrors = {};
                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: "Couldn't update boe!",
                        color: "error",
                    });
                });
        },
    },
};
</script>
